import React, { ChangeEvent, useEffect, useState } from "react";
import Card from "components/card";
import { MdDelete as DeleteIcon, MdEdit as EditIcon } from "react-icons/md";
import { BsFillNodePlusFill, BsArrowDown, BsArrowUp } from "react-icons/bs";
import InputField from "components/fields/InputField";
import GeneralModal from "usefulComponents/Modal/Modal";
import Select from 'react-select'
import DataTable from "components/Datatable/Datatable";
import { GridColDef } from "@mui/x-data-grid";
import { deleteDataById, fetchData, insertData, updatetDataById, updatetManyDataById } from "api";
import { systems } from "api/collection_names";
import { Button } from "@mui/material";
import { SelectModel } from "utils/general-utils";
import { useNavigate } from "react-router-dom";
import { SnackbarState } from "models/user-models";
import AppSnackbar from "components/snakbar";

export interface SystemsType {
    description: string
    priority: number
    _id?: string
}

export interface UpdateSystemsType {
    description: string
    _id?: string
}

const Systems = () => {
    const [open, setOpen] = React.useState(false)
    const [isEdit, setIsEdit] = React.useState(false)
    const [editId, setEditId] = React.useState("0")
    const [rows, setRows] = useState<SystemsType[]>([])
    const [isFiltered, setIsFiltered] = useState<boolean>(false)
    const [dataObj, setDataObj] = useState<SystemsType>({
        description: "",
        priority: 0
    })

    const [dataObjUpdate, setDataObjUpdate] = useState<UpdateSystemsType>({
        description: "",
    })

    const [options, setOptions] = useState<SelectModel[]>([{ value: 'null', label: 'None' }])
    const [loading, setLoading] = useState<boolean>(false)
    const [snackbar, setSnackbar] = useState<SnackbarState>({
        open: false,
        message: '',
        severity: 'info',
    });

    const [dataAfterData, setDataAfterData] = useState<SystemsType[]>()

    const navigate = useNavigate()
    useEffect(() => {
        getSystems()
    }, [])

    const initObj = () => {
        setDataObj({
            description: "",
            priority: 0
        })
    }




    const getSystems = async () => {
        try {

            setLoading(true)
            const res = await fetchData(systems)
            if (res.success) {
                let sortData = res.data.sort((a: any, b: any) => a.priority - b.priority);
                setRows(sortData)
                const arr: SelectModel[] = [{ value: 'null', label: 'None' }]
                for (let index = 0; index < res.data.length; index++) {
                    const x = res.data[index];
                    arr.push({ value: x._id, label: x.description })
                }
                setOptions(arr)
            }
            else {
                setRows([])

                // const isTokenExpired = () => {
                //     const expirationTime = localStorage.getItem('expirationTime');
                //     if (!expirationTime) return true;
                //     return new Date().getTime() > Number(expirationTime);
                //   };
                //   console.log("isTokenExpired++++++",isTokenExpired())

                //   if (isTokenExpired()) {
                //     localStorage.removeItem('expirationTime');
                //     navigate('/auth/sign-in'); 
                //   } 
                //   navigate('/auth/sign-in'); 
                alert("No System found...!")
                navigate('/auth/sign-in');
            }
            setLoading(false)
        } catch (error: any) {
            const alreadyLoggedIn = error.message.endsWith("401")
            if (alreadyLoggedIn) {
                setSnackbar({ open: true, message: "logged in from some other device", severity: 'error' });
                setTimeout(() => {
                    navigate('/auth/sign-in');
                }, 3000)
            }
        }
    }


    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setDataObj((prev) => ({
            ...prev,
            [event.target.name]: event.target.value
        }))

        setDataObjUpdate((prev) => ({
            ...prev,
            [event.target.name]: event.target.value
        }))

    }

    const columns: GridColDef[] = [
        { field: "description", headerName: "Description", flex: 9 },
        {
            field: "actions",
            headerName: "Actions",
            flex: 2,
            sortable: false,
            renderCell: (params: any) => {
                const idx = rows.findIndex((r) => r._id === params.row._id);
                const isUpDisabled = isFiltered || idx <= 0 || rows.length <= 1;
                const isDownDisabled = isFiltered || idx < 0 || idx >= rows.length - 1 || rows.length <= 1;

                return (
                <>
                    <Button
                        title="up"
                        variant="contained"
                        className="disabled:cursor-not-allowed"
                        disabled={isUpDisabled}
                        sx={{
                            width: '30px',
                            height: '30px',
                            minWidth: '30px',
                            mr: '5px',
                            padding: 0,
                            background: "#e2e8f0",
                            color: "#1b2559",
                            "&:hover": { background: "#e2e8f0", opacity: 0.8 },
                            "&:active": { background: "#e2e8f0", opacity: 0.7 },
                            "&:disabled": { background: "#e2e8f0", opacity: 0.5, cursor: "not-allowed" },
                        }}
                        onClick={async () => {
                            if (idx > 0) {
                                setLoading(true);
                                let row1 = rows[idx];
                                let row2 = rows[idx - 1];

                                await updatetDataById(systems, {
                                    description: row1?.description,
                                    priority: row2?.priority
                                }, row1?._id).catch(e => console.log(e));

                                await updatetDataById(systems, {
                                    description: row2?.description,
                                    priority: row1?.priority === row2?.priority ? row2?.priority + 1 : row1?.priority
                                }, row2?._id).catch(e => console.log(e));

                                getSystems();
                                setLoading(false);
                            }
                        }}>
                        <BsArrowUp />
                    </Button>
                    <Button
                        title="down"
                        variant="contained"
                        disabled={isDownDisabled}
                        sx={{
                            width: '30px',
                            height: '30px',
                            minWidth: '30px',
                            mr: '5px',
                            padding: 0,
                            background: "#e2e8f0",
                            color: "#1b2559",
                            "&:hover": { background: "#e2e8f0", opacity: 0.8 },
                            "&:active": { background: "#e2e8f0", opacity: 0.7 },
                            "&:disabled": { background: "#e2e8f0", opacity: 0.5, cursor: "not-allowed" },
                        }}
                        onClick={async () => {
                            if (idx >= 0 && idx < rows.length - 1) {
                                setLoading(true);
                                let row1 = rows[idx];
                                let row2 = rows[idx + 1];

                                await updatetDataById(systems, {
                                    description: row1?.description,
                                    priority: row2?.priority
                                }, row1?._id).catch(e => console.log(e));

                                await updatetDataById(systems, {
                                    description: row2?.description,
                                    priority: row1?.priority === row2?.priority ? row2?.priority - 1 : row1?.priority
                                }, row2?._id).catch(e => console.log(e));

                                getSystems();
                                setLoading(false);
                            }
                        }}>
                        <BsArrowDown />
                    </Button>
                    <Button
                        title="Edit"
                        variant="contained"
                        sx={{
                            width: '30px',
                            height: '30px',
                            minWidth: '30px',
                            mr: '5px',
                            padding: 0,
                            background: "#eed202",
                            color: "white",
                            "&:hover": { background: "#eed202", opacity: 0.8 },
                            "&:active": { background: "#eed202", opacity: 0.7 },
                        }}
                        onClick={() => {
                            setDataObj((prev) => ({
                                ...prev,
                                description: params.row.description
                            }))
                            setOpen(true)
                            setIsEdit(true)
                            setEditId(params.row._id)
                        }}>
                        <EditIcon fontSize="small" />
                    </Button>
                    <Button
                        title="Delete"
                        sx={{
                            width: '30px',
                            height: '30px',
                            minWidth: '30px',
                            mr: '5px',
                            padding: 0,
                            background: "#ff0000",
                            color: "white",
                            "&:hover": { background: "#ff0000", opacity: 0.8 },
                            "&:active": { background: "#ff0000", opacity: 0.7 },
                        }}
                        variant="contained"
                        onClick={async () => {
                            /* eslint-disable no-restricted-globals */
                            if (confirm(`Are you sure to delete ${params.row.description}`)) {

                                const beforeData = [...rows]
                                beforeData.sort((a: any, b: any) => a.priority - b.priority);

                                const index = beforeData.findIndex((item: any) => item._id === params.row._id);
                                const slicedData = beforeData.slice(index + 1);
                                slicedData.forEach((item: any) => {
                                    item.priority = item.priority - 1;
                                });




                                const res = await deleteDataById(systems, params.row._id)
                                if (res.success) {
                                    if (slicedData.length !== 0) {
                                        const updatedNextData = await updatetManyDataById(systems, slicedData)

                                    }
                                    getSystems()
                                }
                                else {
                                    alert(res.message)
                                }
                            }
                        }}>
                        <DeleteIcon fontSize="small" />
                    </Button>
                </>
                );
            },
        }
    ];

    return (
        <div>
            <div className="mt-5">
                <Card extra={"w-full h-full sm:overflow-auto px-8"}>
                    <header className="relative flex items-center justify-between py-5">
                        <h1 className="text-[26px] text-textPrimary font-semibold w-[100%] sm:w-[70%]">Systems</h1>

                        <button onClick={() => {
                            setOpen(true)
                            setIsEdit(false)
                            initObj()
                        }} className={`flex items-center text-sm hover:cursor-pointer bg-surfaceSecondary p-3 text-brand-500 hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70 linear justify-center rounded-lg font-bold transition duration-200`}>
                            Add New System &nbsp;&nbsp; <BsFillNodePlusFill />
                        </button>
                    </header>
                    <GeneralModal openModal={open} title="Add Systems" saveButtonText="Submit" cancelButtonText="Close" onClose={setOpen} onSave={async () => {
                        if (!dataObj.description || dataObj.description.trim() === "") {
                            alert("Description required...!")
                            return
                        }
                        if (!isEdit) {
                            let postdata = dataObj
                            postdata.priority = rows.length
                            const res = await insertData(systems, dataObj)
                            if (res.success) {
                                getSystems()
                                setOpen(false)
                            }
                            else {
                                alert(res.message)
                            }
                        }
                        else {

                            let postData = dataObjUpdate
                            const res = await updatetDataById(systems, postData, editId)
                            if (res.success) {
                                getSystems()
                                setOpen(false)
                            }
                            else {
                                alert(res.message)
                            }

                        }
                    }} >
                        <div className="mt-10 flex justify-between items-center w-[100%]">
                            <div className="w-[450px] mr-5">
                                <InputField
                                    name="description"
                                    variant="auth"
                                    extra="mb-3"
                                    label="Description"
                                    placeholder="Description"
                                    type="text"
                                    id="description"
                                    value={dataObj.description.replace("  ", " ")}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </GeneralModal>

                    <div>
                        <DataTable columns={columns} rows={rows} loading={loading} onFilterActiveChange={setIsFiltered} />
                    </div>
                </Card>
            </div>
            <AppSnackbar
                isOpen={snackbar.open}
                title={snackbar.message}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                severity={snackbar.severity}
            />
        </div>
    );
};

export default Systems;
